import {ArrowDownRight, Sparkles, Activity, Cpu} from 'lucide-react'

function Hero() {
  return (
    <section id="top" className="relative pt-20 pb-28 lg:pt-28 lg:pb-36 overflow-hidden">
      {/* Background ornament */}
      <div className="absolute inset-0 grain opacity-[0.18] pointer-events-none" />
      <div className="absolute top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-gradient-radial from-amber-200/40 via-amber-100/10 to-transparent blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(252,211,77,0.35) 0%, rgba(252,211,77,0.05) 40%, transparent 70%)' }} />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Eyebrow ticker */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-50/60 backdrop-blur-sm">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
            </span>
            <span className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-amber-900">Diagnostic Index · Updated Live</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="font-display text-center text-slate-900 text-[clamp(2.5rem,7vw,6.5rem)] leading-[0.95] font-medium">
          The Ultimate Device
          <br />
          <span className="italic font-light">Lifespan</span>{' '}
          <span className="relative inline-block">
            Configurator
            <svg className="absolute -bottom-3 left-0 w-full" height="18" viewBox="0 0 400 18" fill="none">
              <path d="M2 9 Q 100 2, 200 9 T 398 9" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" fill="none" />
            </svg>
          </span>
        </h1>

        {/* Sub */}
        <p className="mt-12 max-w-2xl mx-auto text-center text-[17px] lg:text-[19px] leading-[1.65] text-slate-600">
          Expert settings checklists, diagnostic tutorials, and battery configurations to squeeze{' '}
          <span className="relative whitespace-nowrap font-semibold text-slate-900">
            30%+ more longevity
            <span className="absolute inset-x-0 -bottom-0.5 h-[6px] bg-amber-300/60 -z-0" />
          </span>{' '}
          out of your everyday tech.
        </p>

        {/* CTA + stats row */}
        <div className="mt-14 flex flex-col items-center gap-10">
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a href="#calculator" className="group inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-slate-900 text-bone hover:bg-slate-800 transition">
              <span style={{ color: '#FAF8F5' }} className="text-[14px] font-medium">Open the Calculator</span>
              <ArrowDownRight className="w-4 h-4 text-amber-400 group-hover:translate-x-0.5 group-hover:translate-y-0.5 transition" />
            </a>
            <a href="#hubs" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border border-slate-900/15 bg-bone/60 backdrop-blur-sm text-slate-900 hover:border-slate-900/30 transition">
              <span className="text-[14px] font-medium">Browse Device Hubs</span>
            </a>
          </div>

          {/* stat pills */}
          <div className="grid grid-cols-3 gap-px bg-slate-900/[0.08] rounded-2xl overflow-hidden max-w-3xl w-full">
            {[
              { Icon: Sparkles, label: 'Optimizations', value: '42+' },
              { Icon: Activity, label: 'Avg. Gain', value: '+38%' },
              { Icon: Cpu, label: 'Devices Indexed', value: '5' },
            ].map((s) => (
              <div key={s.label} className="bg-bone/80 backdrop-blur px-6 py-5 flex items-center gap-4">
                <div className="w-9 h-9 rounded-lg bg-slate-900/[0.04] flex items-center justify-center">
                  <s.Icon className="w-4 h-4 text-amber-600" strokeWidth={2} />
                </div>
                <div>
                  <div className="font-display text-2xl font-medium text-slate-900 leading-none">{s.value}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 mt-1.5">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
